import unstable_styleFunctionSx, { SxProps } from '@mui/system/styleFunctionSx';
import { StyleFunction } from '@mui/system/style';
import { styled } from '@mui/material/styles';

interface Props {
    sx?: SxProps;
}
export const Div = styled('div')<Props>(unstable_styleFunctionSx as StyleFunction<Props>);
